import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  TableCell,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import CustomTable from "../common-components/CustomTable";
import { formatDate } from "../../utils/functions";
import CommonPagination from "../common-components/CommonPagination";
import ListLoadingNew from "../common-components/ListLoadingNew";
import { ArrowRightCircleIcon } from "../../assets/Icon/ArrowIcon";
import { Title } from "@mui/icons-material";
import theme from "../../theme";
import { useNavigate } from "react-router-dom";
import CustomButton from "../common-components/CustomButton";
import { useDispatch } from "react-redux";
import { getOperatingAgreementList } from "../../stores/clients";

const complianceData: any = [{}];

const OperatingAgreementTable = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const [data, setData] = useState<any>();
  const [pageNo, setPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [limit] = useState(10);
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const operatingAgreementStatus: Record<
    number,
    { label: string; bgColor: string; textColor: string }
  > = {
    0: { label: "Pending", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    1: {
      label: "Submitted",
      bgColor: "#EAF1FA",
      textColor: "#2977CC",
    },
    2: {
      label: "Submitted",
      bgColor: "#EAF1FA",
      textColor: "#2977CC",
    },
  };

  const fetchList = async () => {
    await dispatch<any>(getOperatingAgreementList({ page: pageNo, limit }))
      .then((res: any) => {
        if (!res?.payload?.data?.agreements?.length) {
          navigate("/tools/operating-agreement");
          return;
        }
        setData(res?.payload?.data);
        setTotalRecords(res?.payload?.total_records);
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => setIsLoadingList(false));
  };

  useEffect(() => {
    fetchList();
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  if (loading) {
    return <ListLoadingNew />;
  }

  const handlePageChange = (newPage: number) => {
    setPageNo(newPage);
  };

  return (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "20px",
          padding: "20px",
          background: "white",
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
        }}
      >
        <p
          style={{
            fontWeight: 600,
            fontSize: "20px",
          }}
        >
          Operating Agreement
        </p>
        <CustomButton
          btnTitle={"Operating Agreement"}
          minwidth="191px"
          type="button"
          loading={false}
          handleClick={() =>
            navigate("/tools/operating-agreement", {
              state: { fromButton: true },
            })
          }
        />
      </Box>
      <CustomTable
        headings={[
          "SR NO.",
          "Order Id",
          "Service Name",
          "Company",
          "Amount",
          "Created Date",
          "Status",
          "Action",
        ]}
      >
        {isLoadingList ? (
          <TableRow>
            <TableCell colSpan={6} align="center">
              <CircularProgress />
            </TableCell>
          </TableRow>
        ) : (
          data?.agreements?.map((item: any, idx: number) => {
            return (
              <TableRow>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {(pageNo - 1) * limit + idx + 1}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {item?.order_id}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {item?.service_name}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {item?.company}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  ${item?.amount}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {formatDate(item?.created_date)}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  <Box
                    sx={{
                      minWidth: "113px",
                      width: "auto",
                      textAlign: "center",
                      display: "inline-block",
                      padding: "9px",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: "600",
                      backgroundColor:
                        item?.status === "submitted" ? "#EAF1FA" : "#3DC82633",
                      color:
                        item?.status === "submitted" ? "#2977CC" : "#3DC826",
                      whiteSpace: "nowrap",
                      cursor: "pointer",
                    }}
                  >
                    {item?.status?.charAt(0).toUpperCase() +
                      item?.status?.slice(1)}
                  </Box>
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    color: item?.is_buffer ? "red" : "#000",
                  }}
                >
                  <Box
                    onClick={() => {
                      if (item?.status === "completed") {
                        navigate(
                          `/tools/operating-agreement/${item?.order_id}`,
                        );
                      } else {
                        navigate(
                          `/tools/operating-agreement/uploads/${item?.order_id}`,
                        );
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <ArrowRightCircleIcon />
                  </Box>
                </TableCell>
              </TableRow>
            );
          })
        )}
      </CustomTable>
      {data?.agreements?.length === 0 && (
        <div
          style={{
            textAlign: "center",
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          No data found!
        </div>
      )}
      {/* Pagination */}
      {Math.ceil(totalRecords / limit) > 1 && (
        <Box sx={{ display: "flex", justifyContent: "end", mt: 3, mb: 3 }}>
          <CommonPagination
            currentPage={pageNo}
            totalPages={Math.ceil(totalRecords / limit)}
            onPageChange={handlePageChange}
          />
        </Box>
      )}
    </div>
  );
};

export default OperatingAgreementTable;
